/* eslint-disable */

/**
 * ⚠️ This is not owned or maintained by the Arcade team.
 * Please refer to the official Arcade design system for supported and maintained components.
 */
export enum HorizontalAlignment {
  CLIENT_COULD_NOT_PARSE_HORIZONTAL_ALIGNMENT = "CLIENT_COULD_NOT_PARSE_HORIZONTAL_ALIGNMENT",
  HORIZONTALLY_CENTERED = "HORIZONTALLY_CENTERED",
  LEADING = "LEADING",
  TRAILING = "TRAILING",
}
